import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const Triangle = (props: SvgIconProps) => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" style={{ minWidth: '12px' }} x="0px" y="0px" viewBox="0 0 1000 1000" enableBackground="new 0 0 1000 1000">
    <g><path d="M500,38.7l490,922.6H10L500,38.7z" /></g>
  </svg>
);

export default Triangle;
